/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import colors from '~/constants/colors';

interface Props {
  onClick: () => void;
  cooldownTime: number; // Initial cooldown time in seconds
}

const TextWithTimer = (props: Props) => {
  const { onClick, cooldownTime } = props;
  const { t } = useTranslation('ksaApplication');
  const [timer, setTimer] = useState(cooldownTime);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    if (timer > 0) {
      const intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // Cleanup interval when component unmounts or timer reaches zero
      return () => clearInterval(intervalId);
    }
  }, [timer]);

  return (
    <Container>
      {timer > 0 ? (
        <p style={{ fontWeight: 300 }}>
          {t('Get a new code in')}{' '}
          <span style={{ fontWeight: 600 }}>({formatTime(timer)})</span>
        </p>
      ) : (
        <Trans
          ns="ksaOnboarding"
          i18nKey="Didn't receive any code? <1>Try again</1>"
        >
          {"Didn't receive any code? "}
          <LinkButton
            type="button"
            onClick={() => {
              onClick();
              setTimer(cooldownTime); // Restart the timer on click
            }}
          >
            Try again
          </LinkButton>
        </Trans>
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-top: -16px;
  margin-bottom: 48px;
  color: ${colors.textColor};
  span {
    color: ${colors.textColor};
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #0069b1;
  text-decoration: none;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #0069b1;
    outline-offset: 2px;
  }
`;

export default TextWithTimer;
